import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = {
  key: 0,
  class: "spin ion-text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"100px"},
    src: _imports_0
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        logoOnly: true,
        parentPath: "/"
      }),
      _createVNode(_component_ion_content, { ref: "contentEl" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              ($setup.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _hoisted_2,
                    _createVNode(_component_ion_spinner)
                  ]))
                : (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.messages.slice($setup.messages.length-50, $setup.messages.length), (msg) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          lines: "none",
                          key: msg.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card, {
                              color: msg.fromUser ? 'tertiary' : 'light',
                              slot: msg.fromUser ? 'end' : 'start',
                              style: {"padding":"8px","font-size":"16px","white-space":"pre-line"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(msg.content), 1)
                              ]),
                              _: 2
                            }, 1032, ["color", "slot"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      ($setup.latestBotResp)
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 0,
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card, {
                                color: 'light',
                                slot: "start",
                                style: {"padding":"8px","font-size":"16px","white-space":"pre-line"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.latestBotResp), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, {
                    lines: "none",
                    style: {"padding-top":"5px","--padding-start":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_textarea, {
                        fill: "outline",
                        placeholder: "How can I help you?",
                        modelValue: $setup.userPrompt,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userPrompt) = $event)),
                        shape: "round",
                        disabled: $setup.waitingBotResp,
                        onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => ($setup.sendMsg()), ["exact","prevent"]), ["enter"]))
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            color: "primary",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.sendMsg())),
                            disabled: !$setup.userPrompt
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "icon-only",
                                icon: $setup.send
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}